<div style="color: black; position: relative; left: 950px;">
    <h2>Se está imprimiendo tu etiqueta</h2><br>
    <span>Pégala en la parte superior de tu encomienda</span>
</div>
<div class="row" style="color: black; position: relative; left: 950px;">
    <button (click)="continuar()">Ya pegué mi etiqueta</button>
    <button (click)="imprimir()">Reimprimir</button>
    <button (click)="errorPapel()">Error de impresion</button>
</div>
